import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const databricks = defineConnector({
  identifier: "databricks",
  name: "Databricks",
  tagLine: "Data and AI platform",
  logo,
  protocol: "http",
  tags: ["ai", "data", "engineering"],
  defaultUrlPattern: () => "https://.*\\.cloud\\.databricks\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Generate a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Databricks workspace, click your username in the top-right, select **Settings**, then go to **Developer > Access tokens** and select **Generate new token**.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Workspace URL",
          required: true,
          placeholder: "dbc-abcd1234-5678.cloud.databricks.com",
          helperText: "Your Databricks workspace hostname.",
          target: { kind: "configuration", field: "workspaceHost" },
        },
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          placeholder: "dapi0123456789abcdef",
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ workspaceHost }) =>
      `https://${workspaceHost}/api/2.0/clusters/list`,
  },
  publicEnvVars: ({ workspaceHost }) => ({
    DATABRICKS_URL: workspaceHost ? `https://${workspaceHost}` : "",
  }),
});
